const IMAGE_BASE_URL = './img/'

export { IMAGE_BASE_URL }
